import { AppApiGateway } from '@repo/api/web/AppApiGateway'
import type { LoyaltyListTransactionsRequestQuery } from '@repo/api/web/models'
import { inject, injectable } from 'inversify'

@injectable()
export class LoyaltyService {
  protected appConfig: ReturnType<typeof useAppConfig>

  constructor(
    @inject(AppApiGateway)
    readonly api: AppApiGateway,
  ) {
    this.appConfig = useAppConfig()
  }

  getWallet() {
    return this.api.loyaltyGetWallet(this.appConfig.host)
  }

  listTransactions(query: LoyaltyListTransactionsRequestQuery) {
    return this.api.loyaltyListTransactions(this.appConfig.host, query)
  }
}
